import { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import {
  actionButtonsColumn,
  defaultColumn,
  tooltipColumn,
  titlesColumn,
  pillsColumn,
  redirectionColumn,
  percentageBtnColumn,
  upDownNumberColumn,
  actionSelfApraisalButtonsColumn,
  editButtonsColumn,
  hideColumn,
  urlColumn,
  columnRight,
  expanderColumn,
  checkBoxColumn,
  counterColumn,
  moneyColumn,
  columnList
} from "../columns";
import "./styles.css";
import { icons } from "../../../constants";
import { Column } from "primereact/column";
import LoadingFeedback from "../../loadingFeedback";
import { Grid } from "@mui/material";
 
const burnDataColumns = [
  { field: "code", header: "Code" },
  { field: "name", header: "Name" }
];
 
const burnData = [
  { id: "1000", code: "f230fh0g3", name: "Bamboo Watch" },
  { id: "1013", code: "fldsmn31b", name: "Grey T-Shirt" }
];
 
const SimpleTable = ({
  loading,
  columns = burnDataColumns,
  data = burnData,
  buttons,
  scrollHeight,
  text,
  onClickftn,
  hideBtn,
  isPaginated,
  tableStyle,
  tooltipFragment,
  rowExpansionTemplate,
  control,
  onRowSelect,
  globalFilterFields = [],
  emptyMessage = "No se han encontrado registros",
  frozen = false,
  showItemCount = false,
  headerButton,
  headerElement,
  serverPagination = false,
  totalRecords = 0,
  rowsPerPage = 5,
  currentPage = 1,
  onPageChange,
  rows = 10,
  pageSize = 10,
  onPageSizeChange,
  rowClassName,
  /** Oculta el desplegable “filas por página” del paginador (p. ej. tabla con tamaño fijo servidor). */
  hidePaginatorRowsDropdown = false
}) => {
  const [expandedRows, setExpandedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [rowClick, setRowClick] = useState(true);
  const toast = useRef(null);

  const handleSelectionChange = (e) => {
    setSelectedRow(e.value);
    onRowSelect && onRowSelect(e.value);
  };
 
  const getColumnType = (item, i, arrayLength) => {
    const isLastItem = i === arrayLength.length - 1;
 
    const itemData = {
      index: i,
      lastItem: isLastItem,
      ...item
    };
 
    switch (item.columnType) {
      case "titles":
        return titlesColumn(itemData);
      case "counter":
        return counterColumn(itemData);
      case "hide":
        return hideColumn(itemData);
      case "expander":
        return expanderColumn(itemData);
      case "url":
        return urlColumn(itemData);
      case "pills":
        return pillsColumn(itemData);
      case "tooltip":
        return tooltipColumn(itemData, tooltipFragment);
      case "redirection":
        return redirectionColumn(itemData);
      case "percentageBtn":
        return percentageBtnColumn(itemData);
      case "upDownNumber":
        return upDownNumberColumn(itemData);
      case "actionSelfApraisalButtonsColumn":
        return actionSelfApraisalButtonsColumn(
          itemData,
          buttons,
          onClickftn,
          text,
          hideBtn
        );
      case "editButtonsColumn":
        return editButtonsColumn(itemData, buttons, onClickftn, text, data);
      case "actionButtons":
        return actionButtonsColumn(itemData, buttons, onClickftn, text, frozen);
      case "columnRight":
        return columnRight(itemData);
      case "fullText":
        return defaultColumn(itemData, true);
      case "checkBox":
        return checkBoxColumn(itemData);
      case "money-column":
        return moneyColumn(itemData);
      case "columnList":
        return columnList(item);
      case "custom-frozen":
        return (
          <Column
            key={item.field}
            frozen
            header={item.header}
            style={{ width: item?.columnWidth ? item.columnWidth : "auto" }}
            headerClassName={`table-header-styled table-header-blueBlack ${
              item.borderRadius === "left"
                ? "table-header-rounded-left"
                : item.borderRadius === "right"
                ? "table-header-rounded-right"
                : ""
            }`}
            body={(rowData) => <div>{item.render(rowData, control)}</div>}
          />
        );
      case "custom":
        return (
          <Column
            key={item.field}
            style={{ width: item?.columnWidth ? item.columnWidth : "auto" }}
            header={item.header}
            headerClassName="table-header-styled"
            body={(rowData) => <div>{item.render(rowData, control)}</div>}
          />
        );
      default:
        return defaultColumn(itemData);
    }
  };

  // header con buscador y contadores
  const header = (
    <Grid container spacing={1.3}>
      {globalFilterFields.length > 0 && (
        <Grid
          item
          xs={12}
          md={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end"
          }}
        >
          <div className="p-inputgroup">
            <span className="p-inputgroup-addon custom-input-search-icon">
              <img className="btn-icon" src={icons.lupablue} alt="icon" />
            </span>
            <InputText
              className="custom-input-search"
              placeholder="Buscar..."
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
            />
          </div>
        </Grid>
      )}
      {showItemCount && (
        <Grid item xs={12} md={12}>
          <div className="item-count-container">
            <p className="item-count-text">
              Resultado:{" "}
              {(serverPagination ? totalRecords : data?.length) ?? 0}{" "}
              Elementos.
            </p>
          </div>
        </Grid>
      )}
      {headerButton && (
        <Grid
          item
          xs={12}
          md={6}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          {headerButton}
        </Grid>
      )}
      {headerElement && (
        <Grid
          item
          xs={12}
          md={6}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          {headerElement}
        </Grid>
      )}
    </Grid>
  );
 
  const handlePage = (event) => {
    if (!onPageChange) return;
    const newPage = Math.floor(event.first / event.rows) + 1;
    onPageChange(newPage, event.rows);
  };

  return (
    <LoadingFeedback loading={loading}>
    <div className="card simple-table">
      <DataTable
        value={data}
        tableStyle={tableStyle}
        scrollable
        scrollHeight={scrollHeight ?? "800px"}
        showGridlines
        emptyMessage={<span>{emptyMessage}</span>}
        globalFilter={globalFilter}
        globalFilterFields={globalFilterFields}
        header={
          globalFilterFields.length > 0 ||
          showItemCount ||
          headerButton ||
          headerElement
            ? header
            : null
        }
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        selectionMode={rowClick ? null : "radiobutton"}
        selection={selectedRow}
        onSelectionChange={handleSelectionChange}
        rowExpansionTemplate={rowExpansionTemplate}
        paginator={isPaginated}
        lazy={!!serverPagination}
        totalRecords={serverPagination ? totalRecords : undefined}
        rows={serverPagination ? rowsPerPage : rows}
        {...(serverPagination
          ? {
              first: Math.max(0, (currentPage - 1) * rowsPerPage),
              onPage: handlePage
            }
          : {})}
        {...(serverPagination && !hidePaginatorRowsDropdown
          ? { rowsPerPageOptions: [rowsPerPage] }
          : {})}
        {...(isPaginated && hidePaginatorRowsDropdown
          ? {
              paginatorTemplate:
                "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            }
          : {})}
        rowClassName={rowClassName}
      >
        {columns.map((col, i, arr) => getColumnType(col, i, arr))}
      </DataTable>
    </div>
    </LoadingFeedback>
  );
};
 
export default SimpleTable;
